import { render } from "./reappearance.vue?vue&type=template&id=4cf43505&scoped=true&ts=true"
import script from "./reappearance.vue?vue&type=script&lang=ts"
export * from "./reappearance.vue?vue&type=script&lang=ts"

import "./reappearance.vue?vue&type=style&index=0&id=4cf43505&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4cf43505"]])

export default __exports__